import React from "react";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
  aggregateUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import PayrollListlPresenter from "./EmployeeRecordsPresenter";
import Progress from "../../../components/Progress";
import InputFactory from "../../../components/InputFactory";

class EmployeeRecordsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollListlPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      limit: 50,
      current: 1,
      count: 0,
      filters: {},
    };
  }

  getCollectionName() {
    return "employees";
  }

  handleViewRecords(data) {
    this.navigateTo(`/view/employee_records/${data.id}`);
  }

  handleEditRecords(data) {
    this.navigateTo(`/form/employee_records/${data.id}`);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    this.filterSubmit({});
    await this.presenter.getObjects();
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;

    console.log("objects", objects);

    if (!schema) return <Progress />;

    schema.fields = {
      ...schema.fields,
      positionLabel: { type: "String", label: "Position" },
    };

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "email" &&
        fields !== "positionLabel" &&
        fields !== "hired",
    );
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        ![
                          "earnings",
                          "sex",
                          "civil",
                          "month",
                          "year",
                          "lengthOfService",
                          "employmentType",
                        ].includes(field),
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                progress={loading}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                hrAction={this.handleViewRecords.bind(this)}
                editPayrollType={this.handleEditRecords.bind(this)}
                // viewPayroll={this._onViewPayroll.bind(this)}
                // payslip={(data) => this.presenter._onGeneratePayslip(data)}
                // voucher={this.handleDisbursementVoucher.bind(this)}
                // remove={(data) => this.presenter._onDeleteData(data)}
                // printPayslip={(data) =>
                //   this.presenter._onCheckNegativeValues(data)
                // }
                // payroll={(data) => {
                //   this.handleAction(data);
                // }}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Employee Records",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(EmployeeRecordsPage);
